module.exports = __webpack_public_path__ + "static/work04_01-36a6add9d4d44d34442e564679046642.png";